import React, { useState } from "react";
import axios from "axios";
import "./ComplaintForm.css"; // Ensure you create this CSS file
import { useAuth } from "../AuthContext";

const ComplaintForm = () => {
  const [complaint, setComplaint] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const { mobile } = useAuth(); // Assuming useAuth provides the mobile number of the logged in user

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Replace all newline chars, tabs, and consecutive spaces with a single space
    const cleanedComplaint = complaint.replace(/[\s\n\t]+/g, " ").trim();

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/complaints/${mobile}`,
        { complaint: cleanedComplaint, employeeName },
        { withCredentials: true }
      );
      // Set success message
      setSuccessMessage(
        "Your complaint has been submitted to us. We will take action and report to you within 3 hours. For any other enquiry or urgent work, you can call 8725092149"
      );
      // Reset form fields
      setComplaint("");
      setEmployeeName("");
      setError(""); // Clear any existing error messages
    } catch (error) {
      console.error("Error submitting complaint:", error);
      setError("Failed to submit complaint. Please try again.");
      setSuccessMessage(""); // Ensure success message is cleared if there's an error
    }
  };

  return (
    <div className="complaint-form-container">
      {successMessage ? (
        <div className="success-message">{successMessage}</div>
      ) : (
        <form onSubmit={handleSubmit} className="complaint-form">
          <h2>Submit a Complaint</h2>
          <textarea
            name="complaint"
            placeholder="Complaint Message"
            value={complaint}
            onChange={(e) => setComplaint(e.target.value)}
            required
          ></textarea>
          <input
            type="text"
            name="employeeName"
            placeholder="Employee Name (if any)"
            value={employeeName}
            onChange={(e) => setEmployeeName(e.target.value)}
          />
          {error && <div className="form-error">{error}</div>}
          <button type="submit">Submit</button>
        </form>
      )}
    </div>
  );
};

export default ComplaintForm;
